/*! Digital Quran — player redesign + ayah navigation (Digital X).
   Rebuilds the bottom audio player layout, tracks the ayah being recited,
   and adds a "Go to ayah" sheet that opens the reader (with translation)
   or plays from that exact ayah. Works on top of dxl-quran-player.js. */
(function () {
  "use strict";
  var T = {
    en: {
      ayah: "Ayah", of: "of", goto: "Go to ayah", read: "Read", readT: "Read this ayah with translation",
      surah: "Surah", ayahN: "Ayah number", readBtn: "Read with translation", playBtn: "Play from this ayah",
      prevA: "Previous ayah", nextA: "Next ayah", close: "Close", hint: "Tip: you can also type 36:12 in the search box.",
      earlier: "Show earlier verses", intro: "Opening", vol: "Volume", jumpTitle: "Jump to an exact ayah",
      jumpSub: "Pick a surah and ayah, then read the translation or listen from there."
    },
    ms: {
      ayah: "Ayat", of: "daripada", goto: "Pergi ke ayat", read: "Baca", readT: "Baca ayat ini bersama terjemahan",
      surah: "Surah", ayahN: "Nombor ayat", readBtn: "Baca dengan terjemahan", playBtn: "Main dari ayat ini",
      prevA: "Ayat sebelum", nextA: "Ayat seterusnya", close: "Tutup", hint: "Tip: anda juga boleh taip 36:12 di kotak carian.",
      earlier: "Tunjuk ayat sebelumnya", intro: "Pembukaan", vol: "Kelantangan", jumpTitle: "Lompat ke ayat tertentu",
      jumpSub: "Pilih surah dan ayat, kemudian baca terjemahan atau dengar dari situ."
    }
  };
  var $ = function (id) { return document.getElementById(id); };
  function L() {
    try { if (typeof lang === "string") return lang === "ms" ? "ms" : "en"; } catch (e) {}
    var en = $("dxq-langEn");
    return en && en.classList.contains("on") ? "en" : "ms";
  }
  function t(k) { return T[L()][k]; }
  function S() { try { return SURAHS; } catch (e) { return null; } }
  function cur() { try { return current; } catch (e) { return -1; } }
  function qid() { try { return qariState.id; } catch (e) { return 7; } }
  function svg(p, w) { return '<svg width="' + (w || 18) + '" height="' + (w || 18) + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + p + "</svg>"; }
  var IC = {
    book: '<path d="M2 4h7a3 3 0 0 1 3 3v13a2.4 2.4 0 0 0-2.4-2.4H2z"/><path d="M22 4h-7a3 3 0 0 0-3 3v13a2.4 2.4 0 0 1 2.4-2.4H22z"/>',
    hash: '<path d="M4 9h16M4 15h16M10 3 8 21M16 3l-2 18"/>',
    back: '<path d="M11 17 6 12l5-5"/><path d="M18 17l-5-5 5-5"/>',
    fwd: '<path d="m13 17 5-5-5-5"/><path d="m6 17 5-5-5-5"/>',
    vol: '<path d="M11 5 6 9H2v6h4l5 4z"/><path d="M15.5 8.5a5 5 0 0 1 0 7"/><path d="M19 5a10 10 0 0 1 0 14"/>',
    chev: '<path d="m6 9 6 6 6-6"/>',
    x: '<path d="M18 6 6 18M6 6l12 12"/>',
    play: '<path d="M7 4.5v15l12-7.5z" fill="currentColor" stroke="none"/>'
  };

  /* ---------------------------------------------------------- ayah timings */
  var timings = {}; // key qari:surah -> [ms start of ayah1..ayahN] (0-index = ayah 1)
  function timingKey(q, n) { return q + ":" + n; }
  function loadTimings(n) {
    var q = qid(), key = timingKey(q, n);
    if (timings[key]) return Promise.resolve(timings[key]);
    var p;
    if (q === 7) {
      // Alafasy streams from mp3quran (server8/afs → mishary-alafasy/r1, read id 123)
      p = fetch("https://www.mp3quran.net/api/v3/ayat_timing?surah=" + n + "&read=123")
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (arr) {
          var out = [];
          (arr || []).forEach(function (a) { if (a.ayah > 0) out[a.ayah - 1] = a.start_time; });
          return out;
        });
    } else {
      p = fetch("https://api.quran.com/api/v4/chapter_recitations/" + q + "/" + n + "?segments=true")
        .then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (j) {
          var out = [];
          ((j.audio_file || {}).timestamps || []).forEach(function (x) {
            var v = +String(x.verse_key).split(":")[1];
            if (v) out[v - 1] = x.timestamp_from;
          });
          return out;
        });
    }
    return p.then(function (out) {
      if (!out.length) throw 0;
      timings[key] = out;
      return out;
    }).catch(function () { timings[key] = null; return null; });
  }
  function ayahAt(arr, ms) {
    if (!arr) return 0;
    var a = 0;
    for (var i = 0; i < arr.length; i++) { if (arr[i] != null && arr[i] <= ms + 250) a = i + 1; else if (arr[i] > ms) break; }
    return a; // 0 = before ayah 1 (isti'adhah / basmalah)
  }

  /* ---------------------------------------------------------- player layout */
  var P, audio, chip, chipTxt, state = { n: 0, ayah: 0, arr: null };
  function build() {
    P = $("dxq-player");
    audio = $("dxq-audio");
    var wrap = P && P.querySelector(".pwrap");
    if (!wrap || P.classList.contains("dqp")) return !!P;
    P.classList.add("dqp");
    var now = wrap.querySelector(".now"), seekrow = wrap.querySelector(".seekrow"),
        controls = wrap.querySelector(".controls"), btns = controls.querySelector(".btns"),
        speed = $("dxq-speed"), vol = $("dxq-vol"), note = wrap.querySelector(".loading-note"),
        mini = $("dxq-minify"), viz = $("dxq-viz"), meta = now.querySelector(".meta");

    // ayah chip under the surah name — shows live ayah, opens the jump sheet
    chip = document.createElement("button");
    chip.type = "button";
    chip.className = "dqp-ayah";
    chip.innerHTML = svg(IC.hash, 13) + '<span class="dqp-ayah-t"></span>' + svg(IC.chev, 13);
    chipTxt = chip.querySelector(".dqp-ayah-t");
    chip.addEventListener("click", function (e) { e.stopPropagation(); openJump(); });
    meta.appendChild(chip);

    // ayah step buttons around play
    var prevA = mk("button", "pbtn dqp-step", svg(IC.back, 19)), nextA = mk("button", "pbtn dqp-step", svg(IC.fwd, 19));
    prevA.id = "dqp-prevAyah"; nextA.id = "dqp-nextAyah";
    var toggle = $("dxq-toggle");
    btns.insertBefore(prevA, toggle);
    btns.insertBefore(nextA, toggle.nextSibling);
    prevA.addEventListener("click", function () { stepAyah(-1); });
    nextA.addEventListener("click", function () { stepAyah(1); });

    // tools: read · go-to · speed · volume · minimise
    var tools = mk("div", "dqp-tools");
    var read = mk("button", "dqp-read", svg(IC.book, 16) + '<span class="dqp-lbl"></span>');
    read.id = "dqp-read";
    read.addEventListener("click", readHere);
    var jump = mk("button", "dqp-iconbtn dqp-jumpbtn", svg(IC.hash, 17));
    jump.id = "dqp-jumpBtn";
    jump.addEventListener("click", function () { openJump(); });
    var volBox = mk("label", "dqp-vol", svg(IC.vol, 17));
    volBox.appendChild(vol);
    tools.appendChild(read);
    tools.appendChild(jump);
    tools.appendChild(speed);
    tools.appendChild(volBox);
    if (note) tools.appendChild(note);
    tools.appendChild(mini);

    // new grid: [now] [btns / seek] [tools]
    var center = mk("div", "dqp-center");
    center.appendChild(btns);
    center.appendChild(seekrow);
    wrap.innerHTML = "";
    if (viz) { viz.classList.add("dqp-viz"); P.insertBefore(viz, P.firstChild); }
    wrap.appendChild(now);
    wrap.appendChild(center);
    wrap.appendChild(tools);
    controls.remove();
    try { window.dispatchEvent(new Event("resize")); } catch (e) {}

    audio.addEventListener("timeupdate", tick);
    audio.addEventListener("loadedmetadata", sync);
    audio.addEventListener("play", sync);
    var qsel = $("dxq-qari");
    if (qsel) qsel.addEventListener("change", function () { state.n = 0; setTimeout(sync, 400); });
    labels();
    return true;
  }
  function mk(tag, cls, html) {
    var e = document.createElement(tag);
    if (tag === "button") e.type = "button";
    e.className = cls;
    if (html) e.innerHTML = html;
    return e;
  }
  function sync() {
    var s = S(), i = cur();
    if (!s || i < 0) return;
    var n = s[i].n;
    if (state.n === n && state.q === qid()) return tick();
    state.n = n; state.q = qid(); state.arr = undefined; state.ayah = -1;
    paintChip();
    loadTimings(n).then(function (arr) { if (state.n === n) { state.arr = arr; tick(); } });
  }
  function tick() {
    var s = S(), i = cur();
    if (!s || i < 0) return;
    if (s[i].n !== state.n) return sync();
    var a = state.arr ? ayahAt(state.arr, audio.currentTime * 1000) : 0;
    if (a !== state.ayah) { state.ayah = a; paintChip(); }
  }
  function paintChip() {
    if (!chip) return;
    var s = S(), i = cur(), su = s && s[i];
    if (!su) return;
    var txt;
    if (state.arr && state.ayah > 0) txt = t("ayah") + " " + state.ayah + " / " + su.y;
    else if (state.arr && state.ayah === 0) txt = t("intro") + " · " + su.y + " " + t("ayah").toLowerCase();
    else txt = t("goto");
    chipTxt.textContent = txt;
    chip.setAttribute("aria-label", t("goto") + " — " + txt);
    var r = $("dqp-read");
    if (r) r.title = t("readT") + (state.ayah > 0 ? " (" + su.n + ":" + state.ayah + ")" : "");
  }
  function labels() {
    if (!P) return;
    var r = $("dqp-read");
    if (r) { r.querySelector(".dqp-lbl").textContent = t("read"); r.setAttribute("aria-label", t("readT")); }
    var j = $("dqp-jumpBtn");
    if (j) { j.title = t("goto"); j.setAttribute("aria-label", t("goto")); }
    var pa = $("dqp-prevAyah"), na = $("dqp-nextAyah");
    if (pa) { pa.title = t("prevA"); pa.setAttribute("aria-label", t("prevA")); }
    if (na) { na.title = t("nextA"); na.setAttribute("aria-label", t("nextA")); }
    var v = P.querySelector(".dqp-vol");
    if (v) v.title = t("vol");
    paintChip();
    jumpLabels();
    readerLabels();
  }
  function stepAyah(d) {
    var arr = state.arr;
    if (!arr) { audio.currentTime = Math.max(0, Math.min((audio.duration || 0) - 1, audio.currentTime + d * 10)); return; }
    var a = state.ayah, ms = audio.currentTime * 1000, target;
    if (d < 0) {
      // like a track list: first press returns to the start of the current ayah
      if (a > 0 && ms - arr[a - 1] > 1500) target = a;
      else target = Math.max(1, a - 1);
    } else target = Math.min(arr.length, a + 1);
    if (arr[target - 1] == null) return;
    audio.currentTime = arr[target - 1] / 1000 + 0.01;
    if (audio.paused) audio.play().catch(function () {});
    state.ayah = target; paintChip();
  }
  function readHere() {
    var s = S(), i = cur();
    if (!s || i < 0) return;
    openAt(s[i].n, Math.max(1, state.ayah || 1));
  }
  function openAt(n, v) {
    try { if (typeof gotoAyah === "function") return gotoAyah(n + ":" + v); } catch (e) {}
    try { openReader(S()[n - 1], v); } catch (e) {}
  }
  function playAt(n, v) {
    var s = S();
    if (!s) return;
    var idx = n - 1;
    var go = function (arr) {
      var sec = arr && arr[v - 1] != null ? arr[v - 1] / 1000 + 0.01 : 0;
      if (cur() === idx && audio.src) {
        audio.currentTime = sec;
        audio.play().catch(function () {});
      } else {
        try { play(idx, sec || undefined); } catch (e) {}
      }
    };
    loadTimings(n).then(go);
  }

  /* ---------------------------------------------------------- go-to-ayah sheet */
  var J;
  function buildJump() {
    if (J) return J;
    J = mk("div", "dqp-sheet");
    J.hidden = true;
    J.innerHTML =
      '<div class="dqp-card" role="dialog" aria-modal="true" aria-labelledby="dqpJT">' +
      '<div class="dqp-head"><div><h3 id="dqpJT"></h3><p class="dqp-sub"></p></div>' +
      '<button type="button" class="dqp-x">' + svg(IC.x, 18) + "</button></div>" +
      '<label class="dqp-field"><span class="dqp-fl dqp-fl-s"></span><select id="dqpSurah"></select></label>' +
      '<div class="dqp-field"><span class="dqp-fl dqp-fl-a"></span>' +
      '<div class="dqp-num"><button type="button" class="dqp-dec" aria-label="−">−</button>' +
      '<input id="dqpAyah" type="number" inputmode="numeric" min="1" value="1">' +
      '<span class="dqp-of"></span><button type="button" class="dqp-inc" aria-label="+">+</button></div>' +
      '<input id="dqpRange" type="range" min="1" value="1" aria-hidden="true" tabindex="-1"></div>' +
      '<div class="dqp-preview" aria-live="polite"><div class="dqp-pv-ar" lang="ar" dir="rtl"></div><div class="dqp-pv-tr"></div></div>' +
      '<div class="dqp-actions"><button type="button" class="dqp-primary">' + svg(IC.book, 17) + '<span></span></button>' +
      '<button type="button" class="dqp-secondary">' + svg(IC.play, 15) + "<span></span></button></div>" +
      '<p class="dqp-hint"></p></div>';
    document.body.appendChild(J);
    var sel = J.querySelector("#dqpSurah"), num = J.querySelector("#dqpAyah"), rng = J.querySelector("#dqpRange");
    S().forEach(function (s) {
      var o = document.createElement("option");
      o.value = s.n;
      o.textContent = s.n + ". " + s.t + " (" + s.y + ")";
      sel.appendChild(o);
    });
    var clamp = function () {
      var s = S()[sel.value - 1], v = Math.round(+num.value || 1);
      v = Math.max(1, Math.min(s.y, v));
      num.value = v; num.max = s.y; rng.max = s.y; rng.value = v;
      J.querySelector(".dqp-of").textContent = "/ " + s.y;
      preview();
    };
    sel.addEventListener("change", function () { num.value = 1; clamp(); });
    num.addEventListener("change", clamp);
    num.addEventListener("input", function () { if (num.value !== "") clamp(); });
    num.addEventListener("keydown", function (e) { if (e.key === "Enter") { e.preventDefault(); clamp(); go("read"); } });
    rng.addEventListener("input", function () { num.value = rng.value; clamp(); });
    J.querySelector(".dqp-dec").addEventListener("click", function () { num.value = +num.value - 1; clamp(); });
    J.querySelector(".dqp-inc").addEventListener("click", function () { num.value = +num.value + 1; clamp(); });
    J.querySelector(".dqp-x").addEventListener("click", closeJump);
    J.addEventListener("click", function (e) { if (e.target === J) closeJump(); });
    J.addEventListener("keydown", function (e) {
      if (e.key === "Escape") { e.stopPropagation(); closeJump(); }
      if (e.key === "Tab") { // keep focus inside
        var f = J.querySelectorAll("button, select, input:not([tabindex='-1'])"), a = f[0], z = f[f.length - 1];
        if (e.shiftKey && document.activeElement === a) { e.preventDefault(); z.focus(); }
        else if (!e.shiftKey && document.activeElement === z) { e.preventDefault(); a.focus(); }
      }
    });
    J.querySelector(".dqp-primary").addEventListener("click", function () { go("read"); });
    J.querySelector(".dqp-secondary").addEventListener("click", function () { go("play"); });
    J._clamp = clamp;
    jumpLabels();
    return J;
  }
  var pvTimer, pvSeq = 0, pvCache = {};
  function preview() {
    clearTimeout(pvTimer);
    pvTimer = setTimeout(function () {
      var n = +J.querySelector("#dqpSurah").value, v = +J.querySelector("#dqpAyah").value, key = n + ":" + v, seq = ++pvSeq;
      var ar = J.querySelector(".dqp-pv-ar"), tr = J.querySelector(".dqp-pv-tr");
      var tid = L() === "ms" ? 39 : 20, ck = key + "/" + tid;
      var show = function (d) { if (seq !== pvSeq || !d) return; ar.textContent = d.ar; tr.textContent = key + " — " + d.tr; J.querySelector(".dqp-preview").classList.add("on"); };
      if (pvCache[ck]) return show(pvCache[ck]);
      J.querySelector(".dqp-preview").classList.add("busy");
      fetch("https://api.quran.com/api/v4/verses/by_key/" + key + "?translations=" + tid + "&fields=text_uthmani")
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var vv = j.verse || {}, trs = (vv.translations || [])[0] || {};
          var txt = String(trs.text || "").replace(/<sup[^>]*>[\s\S]*?<\/sup>/gi, "").replace(/<[^>]+>/g, "").replace(/\s+/g, " ").trim();
          pvCache[ck] = { ar: vv.text_uthmani || "", tr: txt };
          show(pvCache[ck]);
        })
        .catch(function () {})
        .then(function () { J.querySelector(".dqp-preview").classList.remove("busy"); });
    }, 220);
  }
  function jumpLabels() {
    if (!J) return;
    J.querySelector("#dqpJT").textContent = t("jumpTitle");
    J.querySelector(".dqp-sub").textContent = t("jumpSub");
    J.querySelector(".dqp-fl-s").textContent = t("surah");
    J.querySelector(".dqp-fl-a").textContent = t("ayahN");
    J.querySelector(".dqp-primary span").textContent = t("readBtn");
    J.querySelector(".dqp-secondary span").textContent = t("playBtn");
    J.querySelector(".dqp-hint").textContent = t("hint");
    J.querySelector(".dqp-x").setAttribute("aria-label", t("close"));
    J.querySelector("#dqpAyah").setAttribute("aria-label", t("ayahN"));
    J.querySelector("#dqpSurah").setAttribute("aria-label", t("surah"));
  }
  var lastFocus = null;
  function openJump(n, v) {
    if (!S()) return;
    buildJump();
    var s = S(), i = cur();
    if (!n) {
      try { if (typeof rd !== "undefined" && rd && !$("dxq-readWrap").hidden) { n = rd.s.n; v = firstShown() || 1; } } catch (e) {}
    }
    if (!n && i >= 0) { n = s[i].n; v = state.ayah > 0 ? state.ayah : 1; }
    n = n || 1;
    J.querySelector("#dqpSurah").value = n;
    J.querySelector("#dqpAyah").value = v || 1;
    J._clamp();
    lastFocus = document.activeElement;
    J.hidden = false;
    document.documentElement.classList.add("dqp-lock");
    requestAnimationFrame(function () { J.classList.add("in"); });
    setTimeout(function () { var x = J.querySelector("#dqpAyah"); try { x.focus({ preventScroll: true }); x.select(); } catch (e) {} }, 60);
  }
  function closeJump() {
    if (!J || J.hidden) return;
    J.classList.remove("in");
    document.documentElement.classList.remove("dqp-lock");
    setTimeout(function () { J.hidden = true; }, 180);
    try { lastFocus && lastFocus.focus({ preventScroll: true }); } catch (e) {}
  }
  function go(kind) {
    var n = +J.querySelector("#dqpSurah").value, v = +J.querySelector("#dqpAyah").value || 1;
    closeJump();
    if (kind === "read") openAt(n, v);
    else {
      try { var rw = $("dxq-readWrap"); if (rw && !rw.hidden) $("dxq-readClose").click(); } catch (e) {}
      playAt(n, v);
    }
  }

  /* ---------------------------------------------------------- reader additions */
  function firstShown() {
    var b = $("dxq-readBody"), f = b && b.querySelector(".rv[data-key]");
    return f ? +f.dataset.key.split(":")[1] : 0;
  }
  function readerAdd() {
    var foot = document.querySelector("#dxq-readWrap .qread-foot"), prog = $("dxq-readProg");
    if (foot && prog && !foot.querySelector(".dqp-rjump")) {
      var b = mk("button", "q-chip dqp-rjump", svg(IC.hash, 14));
      b.id = "dqp-readJump";
      prog.parentNode.insertBefore(b, prog);
      b.appendChild(prog);
      b.addEventListener("click", function () { openJump(); });
    }
    var body = $("dxq-readBody");
    if (body && !body._dqp) {
      body._dqp = true;
      new MutationObserver(earlierBtn).observe(body, { childList: true });
      // "Load next verses": show progress, then bring the first new verse into view
      var more = $("dxq-readMore");
      if (more) more.addEventListener("click", function () {
        try {
          if (!rd || rd.next > rd.s.y || more.classList.contains("dqp-busy")) return;
          var target = rd.s.n + ":" + rd.next, label = more.textContent, n0 = rd.s.n, rd0 = rd;
          more.classList.add("dqp-busy");
          more.setAttribute("aria-busy", "true");
          more.textContent = L() === "ms" ? "Memuatkan ayat…" : "Loading verses…";
          var tries = 0;
          (function wait() {
            var el = body.querySelector('.rv[data-key="' + target + '"]');
            var moved = !rd || rd !== rd0 || rd.s.n !== n0;
            if (el || moved || ++tries > 100 || (rd && !rd.busy && tries > 6 && !el && body.querySelector(".q-note.err"))) {
              more.classList.remove("dqp-busy");
              more.removeAttribute("aria-busy");
              try { more.textContent = I18N[lang].readMore || label; } catch (e) { more.textContent = label; }
              if (el && !moved) {
                var top = el.getBoundingClientRect().top - body.getBoundingClientRect().top + body.scrollTop - 8;
                body.scrollTo({ top: top, behavior: RM ? "auto" : "smooth" });
                el.classList.add("dqp-flash");
                setTimeout(function () { el.classList.remove("dqp-flash"); }, 1600);
              }
              return;
            }
            setTimeout(wait, 120);
          })();
        } catch (e) {}
      }, true);
      // keep reading without tapping: load the next batch when the end comes into view
      body.addEventListener("scroll", function () {
        try {
          if (!rd || rd.busy || rd.next > rd.s.y || (more && more.classList.contains("dqp-busy"))) return;
          if (body.scrollHeight - body.scrollTop - body.clientHeight < 260) readBatch();
        } catch (e) {}
      }, { passive: true });
    }
    readerLabels();
  }
  function readerLabels() {
    var b = $("dqp-readJump");
    if (b) { b.title = t("goto"); b.setAttribute("aria-label", t("goto")); }
    var e = document.querySelector("#dxq-readBody .dqp-earlier span");
    if (e) e.textContent = t("earlier");
  }
  function earlierBtn() {
    var body = $("dxq-readBody");
    if (!body) return;
    var first = firstShown(), have = body.querySelector(".dqp-earlier");
    if (!first || first <= 1) { if (have) have.remove(); return; }
    if (have) { if (body.firstElementChild !== have) body.insertBefore(have, body.firstChild); return; }
    var b = mk("button", "q-chip dqp-earlier", svg('<path d="m18 15-6-6-6 6"/>', 15) + "<span></span>");
    b.querySelector("span").textContent = t("earlier");
    body.insertBefore(b, body.firstChild);
    b.addEventListener("click", function () {
      var s = rd.s, target = firstShown(), from = Math.max(1, target - 10);
      openReader(s, from);
      var tries = 0;
      (function wait() {
        if (++tries > 80) return;
        var el = body.querySelector('.rv[data-key="' + s.n + ":" + target + '"]');
        if (el) { el.scrollIntoView({ block: "start" }); el.classList.add("dqp-flash"); setTimeout(function () { el.classList.remove("dqp-flash"); }, 1600); return; }
        if (!rd.busy && rd.next <= target) readBatch();
        setTimeout(wait, 150);
      })();
    });
  }

  /* ---------------------------------------------------------- "36:12" in searches */
  function hookSearch() {
    var RE = /^\s*(\d{1,3})\s*[:.]\s*(\d{1,3})\s*$/;
    var form = $("dqhForm"), q = $("dqhQ");
    if (form && q && !form._dqp) {
      form._dqp = true;
      form.addEventListener("submit", function (e) {
        var m = RE.exec(q.value);
        if (m && +m[1] >= 1 && +m[1] <= 114) { e.preventDefault(); e.stopImmediatePropagation(); openAt(+m[1], Math.min(+m[2] || 1, S()[+m[1] - 1].y)); }
      }, true);
    }
    var bq = $("dxq-q");
    if (bq && !bq._dqp) {
      bq._dqp = true;
      bq.addEventListener("keydown", function (e) {
        if (e.key !== "Enter") return;
        var m = RE.exec(bq.value);
        if (m && +m[1] >= 1 && +m[1] <= 114) { e.preventDefault(); openAt(+m[1], Math.min(+m[2] || 1, S()[+m[1] - 1].y)); }
      });
    }
    // a "Go to ayah" chip beside the quick-open chips in the hero
    var quick = document.querySelector(".dqh-quick");
    if (quick && !quick.querySelector(".dqp-hjump")) {
      var c = mk("button", "dqp-hjump", svg(IC.hash, 13) + "<span></span>");
      quick.appendChild(c);
      c.addEventListener("click", function () { openJump(36, 1); });
    }
    var hj = document.querySelector(".dqp-hjump span");
    if (hj) hj.textContent = t("goto");
  }

  /* ---------------------------------------------------------- one language at a time
     BM mode has no native Malay tafsir/hadith source, so English sources are machine
     translated. Make that reliable (Arabic quotes are never sent to the translator,
     retries + a second endpoint + a persistent cache) and never fall back to showing
     English text in BM mode — show a retry instead. */
  var AR_RUN = /[؀-ۿݐ-ݿࢠ-ࣿﭐ-﷿ﹰ-﻿](?:[؀-ۿݐ-ݿࢠ-ࣿﭐ-﷿ﹰ-﻿​-‏⁠-⁯◌\s«».,:;!?()\-،؛؟۔]*[؀-ۿݐ-ݿࢠ-ࣿﭐ-﷿ﹰ-﻿])?/g;
  var MTK = "dxq-mt-v1", mtStore = {};
  try { mtStore = JSON.parse(localStorage.getItem(MTK) || "{}") || {}; } catch (e) { mtStore = {}; }
  var mtSaveT;
  function mtSave() {
    clearTimeout(mtSaveT);
    mtSaveT = setTimeout(function () {
      try {
        var keys = Object.keys(mtStore);
        if (keys.length > 1500) keys.slice(0, keys.length - 1200).forEach(function (k) { delete mtStore[k]; });
        localStorage.setItem(MTK, JSON.stringify(mtStore));
      } catch (e) { mtStore = {}; try { localStorage.removeItem(MTK); } catch (e2) {} }
    }, 800);
  }
  function hashStr(s) { var h = 5381; for (var i = 0; i < s.length; i++) h = (h * 33 + s.charCodeAt(i)) >>> 0; return h.toString(36) + s.length; }
  function sleep(ms) { return new Promise(function (r) { setTimeout(r, ms); }); }
  function gtxOnce(q, sl, tl) {
    return fetch("https://translate.googleapis.com/translate_a/single?client=gtx&sl=" + sl + "&tl=" + tl + "&dt=t&q=" + encodeURIComponent(q))
      .then(function (r) { if (!r.ok) throw new Error("gtx " + r.status); return r.json(); })
      .then(function (j) { return (j[0] || []).map(function (x) { return x[0]; }).join(""); });
  }
  function dictOnce(q, sl, tl) {
    return fetch("https://clients5.google.com/translate_a/t?client=dict-chrome-ex&sl=" + sl + "&tl=" + tl + "&q=" + encodeURIComponent(q))
      .then(function (r) { if (!r.ok) throw new Error("dict " + r.status); return r.json(); })
      .then(function (j) {
        var v = Array.isArray(j) ? j[0] : j;
        if (Array.isArray(v)) v = v[0];
        if (typeof v !== "string") throw new Error("dict shape");
        return v;
      });
  }
  async function mtChunk(q, sl, tl) {
    var key = sl + ">" + tl + ":" + hashStr(q);
    if (mtStore[key]) return mtStore[key];
    var last;
    for (var a = 0; a < 4; a++) {
      try {
        var v = a % 2 === 0 ? await gtxOnce(q, sl, tl) : await dictOnce(q, sl, tl);
        if (v && v.trim()) { mtStore[key] = v; mtSave(); return v; }
      } catch (e) { last = e; }
      await sleep([300, 700, 1400, 2400][a]);
    }
    throw last || new Error("mt failed");
  }
  async function mtPlain(text, sl, tl) {
    // ~1500-char chunks on sentence boundaries, line breaks preserved
    var sens = text.match(/[^.!?\n]+[.!?]+[\s"')\]]*|[^.!?\n]+\n?|\n/g) || [text], parts = [], buf = "";
    sens.forEach(function (s) { if (buf && buf.length + s.length > 1500) { parts.push(buf); buf = s; } else buf += s; });
    if (buf) parts.push(buf);
    var out = [];
    for (var i = 0; i < parts.length; i++) out.push(await mtChunk(parts[i], sl, tl));
    return out.join(" ");
  }
  async function mtProtected(text, sl, tl) {
    sl = sl || "en"; tl = tl || "ms";
    if (sl === "auto" || sl === "ar") return mtPlain(text, sl, tl);
    // split out Arabic runs so quoted ayat/hadith are kept exactly as written
    var segs = [], last = 0, m;
    AR_RUN.lastIndex = 0;
    while ((m = AR_RUN.exec(text))) {
      if (m[0].replace(/[^؀-ۿ]/g, "").length < 2) continue;
      if (m.index > last) segs.push({ t: text.slice(last, m.index) });
      segs.push({ t: m[0], ar: true });
      last = m.index + m[0].length;
    }
    if (last < text.length) segs.push({ t: text.slice(last) });
    if (!segs.some(function (s) { return s.ar; })) return mtPlain(text, sl, tl);
    var todo = segs.filter(function (s) { return !s.ar && /[A-Za-z]{2}/.test(s.t); });
    if (todo.length) {
      var joined = todo.map(function (s) { return s.t.replace(/\n/g, " ").trim(); }).join("\n");
      var res = (await mtPlain(joined, sl, tl)).split(/\s*\n\s*/);
      if (res.length !== todo.length) {
        res = [];
        for (var i = 0; i < todo.length; i++) res.push(await mtPlain(todo[i].t.trim(), sl, tl));
      }
      todo.forEach(function (s, i) {
        var lead = /^\s/.test(s.t) ? " " : "", trail = /\s$/.test(s.t) ? " " : "";
        s.out = lead + (res[i] || s.t).trim() + trail;
      });
    }
    return segs.map(function (s) { return s.out != null ? s.out : s.t; }).join("").replace(/\s{2,}/g, " ").trim();
  }
  var MS_UI = { load: "Menterjemah ke Bahasa Melayu…", err: "Terjemahan Bahasa Melayu tidak dapat dimuatkan buat masa ini.", retry: "Cuba lagi" };
  function patchLanguage() {
    try {
      // the reader + homepage use "Tajwid" in Malay
      if (typeof I18N === "object" && I18N.ms) {
        if (I18N.ms.taj === "Tajweed") I18N.ms.taj = "Tajwid";
        if (I18N.ms.dqTajL) I18N.ms.dqTajL = I18N.ms.dqTajL.replace("Tajweed", "Tajwid");
        if (I18N.ms.dqTajT) I18N.ms.dqTajT = I18N.ms.dqTajT.replace("Tajweed", "Tajwid");
      }
    } catch (e) {}
    try { if (typeof mtViaPublic === "function") mtViaPublic = mtProtected; } catch (e) {}
    try { if (typeof mtViaProxy === "function") mtViaProxy = function () { return Promise.reject(new Error("proxy off")); }; } catch (e) {}
    try {
      if (typeof attachMalayTafsir === "function" && typeof translateTafsirBox === "function") {
        attachMalayTafsir = function (container, enBox, noteText) {
          if (L() !== "ms" || !enBox.textContent.trim()) return;
          var msBox = document.createElement("div");
          msBox.className = "taf";
          var status = document.createElement("div");
          status.className = "q-note dqp-mt";
          container.appendChild(msBox);
          container.appendChild(status);
          enBox.style.display = "none";
          var run = function () {
            msBox.innerHTML = "";
            if (noteText) {
              var head = document.createElement("div"); head.className = "taf-head";
              var note = document.createElement("div"); note.className = "q-note"; note.textContent = noteText;
              head.appendChild(note); msBox.appendChild(head);
            }
            status.innerHTML = "";
            status.textContent = MS_UI.load;
            status.hidden = false;
            translateTafsirBox(enBox, msBox).then(function () { status.hidden = true; }).catch(function () {
              status.textContent = MS_UI.err + " ";
              var b = document.createElement("button");
              b.type = "button"; b.className = "q-chip dqp-retry"; b.textContent = MS_UI.retry;
              b.addEventListener("click", function (e) { e.stopPropagation(); run(); });
              status.appendChild(b);
            });
          };
          run();
        };
      }
    } catch (e) {}
    try { if (typeof applyLang === "function") applyLang(); } catch (e) {}
  }
  // if the language changes while the reader is open, re-render it in the new language
  function relangReader() {
    try {
      var rw = $("dxq-readWrap");
      if (rw && !rw.hidden && rd && rd.s) openReader(rd.s, firstShown() || 1);
    } catch (e) {}
  }

  /* ---------------------------------------------------------- structured tafsir
     The English tafsir editions arrive as plain text with blank-line paragraphs.
     Rebuild them into sections (headings), ayah cards (Arabic + meaning + explanation),
     hadith cards, readable paragraphs, a contents strip and reading controls.
     BM: every English string is machine-translated (Arabic kept verbatim). */
  var TT = {
    en: { src: "Tafsir", orig: "Original Arabic", origHide: "Hide original", isnad: "Chain of narrators (isnad)",
      noteAr: "Automatic translation from the original Arabic. Tap \u201cOriginal Arabic\u201d to read the source text.", issue: "Issue", part: "Part", covers: "Covers", min: "min read", toc: "In this tafsir", intro: "Introduction", expand: "Expand all", collapse: "Collapse all",
      hadith: "Hadith", ayah: "Ayah", quoted: "Related ayah", meaning: "Meaning", expl: "Explanation", smaller: "Smaller text", larger: "Larger text",
      none: "No tafsir is available for this ayah.", err: "Couldn't load the tafsir. Please try again.", retry: "Try again",
      trErr: "Part of the Malay translation couldn't load.", loading: "Loading tafsir…", translating: "Translating…", note: "", grade: "Grading" },
    ms: { src: "Tafsir", orig: "Teks asal (Arab)", origHide: "Sembunyi teks asal", isnad: "Rantaian perawi (sanad)",
      noteAr: "Terjemahan automatik daripada teks asal Arab. Tekan \u201cTeks asal\u201d untuk melihat bahasa Arab.", issue: "Masalah", part: "Bahagian", covers: "Merangkumi", min: "min bacaan", toc: "Kandungan tafsir", intro: "Pengenalan", expand: "Buka semua", collapse: "Tutup semua",
      hadith: "Hadis", ayah: "Ayat", quoted: "Ayat berkaitan", meaning: "Maksud", expl: "Huraian", smaller: "Tulisan kecil", larger: "Tulisan besar",
      none: "Tiada tafsir untuk ayat ini.", err: "Tafsir tidak dapat dimuatkan. Sila cuba lagi.", retry: "Cuba lagi",
      trErr: "Sebahagian terjemahan Bahasa Melayu tidak dapat dimuatkan.", loading: "Memuatkan tafsir…", translating: "Menterjemah…",
      note: "Terjemahan automatik daripada teks Inggeris; teks Arab dikekalkan.", grade: "Darjat" }
  };
  function tt(k) { return TT[L()][k]; }
  var AR_CH = /[؀-ۿݐ-ݿࢠ-ࣿﭐ-﷿ﹰ-﻿]/g;
  function arRatio(t) { var a = (t.match(AR_CH) || []).length, all = t.replace(/[\s\d\p{P}]/gu, "").length || 1; return a / all; }
  function rawToText(raw) {
    if (!/<\/?(p|h[1-6]|div|br|li|span)[\s>]/i.test(raw)) return raw;
    var doc = new DOMParser().parseFromString(raw, "text/html"), out = [];
    (function walk(n) {
      n.childNodes.forEach(function (c) {
        if (c.nodeType === 3) { out.push(c.textContent); return; }
        if (c.nodeType !== 1) return;
        var block = /^(P|DIV|H[1-6]|LI|BLOCKQUOTE|UL|OL)$/.test(c.tagName);
        if (block) out.push("\n\n");
        if (c.tagName === "BR") out.push("\n\n");
        walk(c);
        if (block) out.push("\n\n");
      });
    })(doc.body);
    return out.join("");
  }
  // split "(meaning) rest" — balanced parentheses
  function splitParen(t) {
    t = t.trim();
    if (t[0] !== "(") return null;
    var d = 0;
    for (var i = 0; i < t.length; i++) {
      if (t[i] === "(") d++;
      else if (t[i] === ")") { d--; if (d === 0) return { inner: t.slice(1, i).trim(), rest: t.slice(i + 1).trim() }; }
    }
    return null;
  }
  function tidyRest(r) {
    var ref = null, m = /^\((\d{1,3}:\d{1,3}(?:-\d{1,3})?)\)\s*[.,;]?\s*/.exec(r);
    if (m) { ref = m[1]; r = r.slice(m[0].length); }
    r = r.replace(/^(means|meaning|i\.e\.|that is)[,:]?\s+/i, "").trim();
    if (r) r = r.charAt(0).toUpperCase() + r.slice(1);
    return { ref: ref, text: r };
  }
  function isHeading(t, next) {
    if (t.length < 3 || t.length > 90) return false;
    if (/[.!?:;,»"')\]]$/.test(t) || /^[(«"]/.test(t)) return false;
    if (arRatio(t) > 0.3) return false;
    if (t.split(/\s+/).length > 14) return false;
    return !!next;
  }
  function chunkPara(t) {
    if (t.length < 520) return [t];
    var sents = (typeof splitSentences === "function" ? splitSentences(t) : t.split(/(?<=[.!?])\s+/)), out = [], buf = "";
    sents.forEach(function (s) { buf += (buf ? " " : "") + s; if (buf.length > 320) { out.push(buf); buf = ""; } });
    if (buf.trim()) { if (out.length && buf.length < 120) out[out.length - 1] += " " + buf; else out.push(buf); }
    return out;
  }
  function parseTafsir(text) {
    var raw = text.replace(/\r/g, "").split(/\n\s*\n/).map(function (b) { return b.replace(/\s*\n\s*/g, " ").trim(); }).filter(Boolean);
    var secs = [{ title: null, items: [] }], meta = [], prevQuote = null, saidHadith = false;
    for (var i = 0; i < raw.length; i++) {
      var b = raw[i], next = raw[i + 1], sec = secs[secs.length - 1];
      var ratio = arRatio(b);
      if (ratio > 0.6) {
        var had = /^\s*«/.test(b) || saidHadith;
        var item = { k: had ? "hadith" : "ayah", ar: b.replace(/^«\s*|\s*»$/g, ""), mean: "", rest: [] };
        sec.items.push(item); prevQuote = item; saidHadith = false; continue;
      }
      if (prevQuote && b[0] === "(") {
        var sp = splitParen(b);
        if (sp) {
          prevQuote.mean = sp.inner;
          var tr = tidyRest(sp.rest);
          if (tr.ref) prevQuote.ref = tr.ref;
          if (tr.text) {
            // grading sentence right after a hadith → chip inside the card
            if (prevQuote.k === "hadith") {
              var gm = /^([^.]*\b(chain of narration|isnad|is sahih|is hasan|jayyid|da'?if|authentic)\b[^.]*\.)\s*/i.exec(tr.text);
              if (gm) { prevQuote.grade = gm[1].trim(); tr.text = tr.text.slice(gm[0].length).trim(); }
            }
            if (tr.text) chunkPara(tr.text).forEach(function (c, ci) { sec.items.push({ k: "p", t: c, exp: ci === 0 }); });
          }
          prevQuote = null;
          saidHadith = /(said|says|stated)\s*[:,]?\s*["“]?\s*$/i.test(tr.text || "") && /(Messenger|Prophet|Rasul)/i.test(tr.text || "");
          continue;
        }
      }
      prevQuote = null;
      if (isHeading(b, next)) {
        // two headings in a row at the very top: the first is a note ("Which was revealed in Makkah")
        if (!sec.items.length && !sec.title && next && isHeading(next, raw[i + 2]) && secs.length === 1) { meta.push(b); continue; }
        if (!sec.items.length && sec.title == null && secs.length === 1) sec.title = b;
        else secs.push({ title: b, items: [] });
        continue;
      }
      saidHadith = /(said|says)\s*[:,]?\s*["“]?\s*$/i.test(b) && /(Messenger|Prophet)/i.test(b);
      // Ma'arif style: "The second sentence <Arabic> ..." → its own section titled by the Arabic phrase
      var om = /^(?:The\s+)?(first|second|third|fourth|fifth|sixth|seventh|eighth|ninth|tenth)\s+(sentence|phrase|part)\b/i.exec(b);
      if (om) {
        AR_RUN.lastIndex = 0;
        var am = AR_RUN.exec(b);
        if (am && am[0].replace(/[^\u0600-\u06FF]/g, "").length >= 3) { secs.push({ title: am[0].trim(), arTitle: true, items: [] }); sec = secs[secs.length - 1]; }
      }
      chunkPara(b).forEach(function (c) { sec.items.push({ k: "p", t: c }); });
    }
    return { meta: meta, secs: secs.filter(function (s) { return s.items.length || s.title; }) };
  }
  function setRich(node, text) {
    node.textContent = "";
    var last = 0, m;
    AR_RUN.lastIndex = 0;
    while ((m = AR_RUN.exec(text))) {
      if (m[0].replace(/[^\u0600-\u06FF]/g, "").length < 3) continue;
      if (m.index > last) node.appendChild(document.createTextNode(text.slice(last, m.index)));
      var sp = document.createElement("span");
      sp.className = "dqt-arin"; sp.lang = "ar"; sp.dir = "rtl"; sp.textContent = m[0];
      node.appendChild(sp);
      last = m.index + m[0].length;
    }
    if (last < text.length) node.appendChild(document.createTextNode(text.slice(last)));
  }
  // Arabic-source tafsir (Al-Muyassar, Al-Wasit, As-Sa'di, Al-Baghawi, Al-Qurtubi, At-Tabari):
  // sections at each quoted Quran phrase / numbered issue / "* * *" break, readable paragraphs,
  // isnad chains folded away, footnote numbers removed.
  var AR_ORD = ["الأولى", "الثانية", "الثالثة", "الرابعة", "الخامسة", "السادسة", "السابعة", "الثامنة", "التاسعة", "العاشرة", "الحادية عشرة", "الثانية عشرة", "الثالثة عشرة", "الرابعة عشرة", "الخامسة عشرة", "السادسة عشرة", "السابعة عشرة", "الثامنة عشرة", "التاسعة عشرة", "العشرون"];
  function arChunks(t) {
    t = t.replace(/\s+/g, " ").trim();
    if (!t) return [];
    var sents = t.split(/(?<=[.؟!])\s+(?=\S)/), out = [], buf = "";
    sents.forEach(function (x) {
      if (x.length > 520) { // very long comma-joined sentence: break at "،"
        var parts = x.split(/(?<=،)\s+/), b2 = "";
        parts.forEach(function (pp) { if (b2 && (b2 + " " + pp).length > 420) { out.push(((buf ? buf + " " : "") + b2).trim()); buf = ""; b2 = pp; } else b2 += (b2 ? " " : "") + pp; });
        x = b2;
      }
      buf += (buf ? " " : "") + x;
      if (buf.length > 380) { out.push(buf.trim()); buf = ""; }
    });
    if (buf.trim()) { if (out.length && buf.length < 90) out[out.length - 1] += " " + buf.trim(); else out.push(buf.trim()); }
    return out;
  }
  var ISNAD_RE = /^((?:حدثنا|حدثني|أخبرنا|أخبرني|أنبأنا|ثنا)\s[\s\S]{10,600}?)(?=(?:قال\s*:?\s*)?(?:قال رسول الله|أن رسول الله|أن النبي|عن النبي|قال النبي|سمعت رسول الله|في قوله|قوله\s*[:(]|قال\s*:\s*["«(]))/;
  function arPara(text, items) {
    text = text.replace(/\s*\(\d{1,3}\)\s*/g, " ").trim();
    if (!text) return;
    var m = ISNAD_RE.exec(text);
    if (m && m[1].length < text.length - 20) { items.push({ k: "isnad", t: m[1].trim() }); text = text.slice(m[1].length).trim(); }
    arChunks(text).forEach(function (c) { items.push({ k: "p", t: c }); });
  }
  function parseArabicTafsir(text) {
    text = text.replace(/\r/g, "");
    var secs = [{ title: null, items: [] }];
    var blocks = text.split(/\n\s*\*\s*\*\s*\*\s*\n|\n\s*\n/);
    var QUOTE = /\{\s*([^{}]{2,400}?)\s*\}|\(\s*([؀-ۿ][^()]{2,320}?)\s*\)/g;
    blocks.forEach(function (blk, bi) {
      blk = blk.replace(/\s+/g, " ").trim();
      if (!blk || /^[*\s]+$/.test(blk)) return;
      // Tabari: "القول في تأويل قوله تعالى : <phrase>" opens a section
      var tm = /^القول في تأويل قوله(?: تعالى| عز وجل| جل ثناؤه)?\s*:?\s*(.{2,220})$/.exec(blk);
      if (tm) { secs.push({ title: tm[1].replace(/\(\d+\)/g, "").trim(), arTitle: true, items: [] }); return; }
      // Qurtubi: numbered issues "الأولى : ..."
      var ordRe = new RegExp("(?:^|[\\s:.،])(" + AR_ORD.join("|") + ")\\s*:", "g"), cuts = [], om;
      while ((om = ordRe.exec(blk))) { var pre1 = om[0].indexOf(om[1]); cuts.push({ i: om.index + pre1, n: AR_ORD.indexOf(om[1]) + 1, len: om[0].length - pre1 }); }
      var seqOk = cuts.length >= 2 && cuts[0].n === 1 && cuts.every(function (c, i) { return c.n === i + 1; }) && /مسائل|مسألة/.test(blk.slice(0, Math.max(0, cuts[0].i) + 40));
      if (seqOk) {
        var head = blk.slice(0, cuts[0].i).trim();
        if (head) arSegment(head, secs);
        cuts.forEach(function (c, ci) {
          var body = blk.slice(c.i + c.len, ci + 1 < cuts.length ? cuts[ci + 1].i : blk.length).trim();
          secs.push({ title: tt("issue") + " " + c.n, noTr: true, items: [] });
          arSegment(body, secs, true);
        });
        return;
      }
      arSegment(blk, secs);
    });
    function arSegment(t, secs, keepSec) {
      var last = 0, m, found = [];
      QUOTE.lastIndex = 0;
      while ((m = QUOTE.exec(t))) {
        var q = (m[1] || m[2] || "").trim();
        var words = q.split(/\s+/).length;
        if (words < 2 || arRatio(q) < 0.7 || /صلى الله عليه|رضي الله|عليه السلام/.test(q)) continue;
        var after = t.slice(m.index + m[0].length, m.index + m[0].length + 14);
        var before = t.slice(Math.max(0, m.index - 22), m.index);
        var isBrace = !!m[1];
        var marks = (q.match(/[\u064B-\u0652]/g) || []).length, letters = (q.match(/[\u0621-\u064A]/g) || []).length || 1;
        var vowelled = marks / letters > 0.35;
        var lead = /^\s*(?:أي|أى|يعني|:)/.test(after) || /(?:قوله(?: تعالى| عز وجل| جل ثناؤه)?\s*:?\s*)$/.test(before);
        if (isBrace || lead || (vowelled && !/(?:قال|يقول|فقال)\s*:?\s*$/.test(before))) found.push({ s: m.index, e: m.index + m[0].length, q: q });
      }
      var cur = secs[secs.length - 1];
      if (found.length < 1 || (found.length === 1 && t.length < 600 && !keepSec)) {
        // short / no explicit phrases: plain paragraphs (quotes stay inline)
        arPara(t, cur.items);
        return;
      }
      found.forEach(function (f, fi) {
        var pre = t.slice(last, f.s).replace(/(?:قوله(?: تعالى| عز وجل)?|وقوله)\s*:?\s*$/, "").trim();
        if (pre.replace(/[^؀-ۿ]/g, "").length > 12) arPara(pre, secs[secs.length - 1].items);
        if (keepSec) secs[secs.length - 1].items.push({ k: "phrase", ar: f.q });
        else secs.push({ title: f.q, arTitle: true, items: [] });
        last = f.e;
      });
      var rest = t.slice(last).replace(/^\s*[:،.]\s*/, "").trim();
      if (rest) arPara(rest, secs[secs.length - 1].items);
    }
    return { meta: [], secs: secs.filter(function (s) { return s.items.length; }) };
  }
  window.DXQ_parseArabicTafsir = parseArabicTafsir;
  function el(tag, cls, text) { var e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }
  var tafFs = 17;
  try { tafFs = +localStorage.getItem("dqt-fs") || 17; } catch (e) {}
  function renderTafsir(host, model, info) {
    var ms = L() === "ms", jobs = [], arSrc = info.src === "ar";
    var NEED = arSrc || ms, SL = arSrc ? "ar" : "en", TL = ms ? "ms" : "en";
    var curSec = -1;
    function job(o) { if (!NEED) return; o.sl = SL; o.tl = TL; o.sec = curSec; jobs.push(o); }
    var root = el("div", "dqt" + (arSrc ? " dqt-arsrc" : ""));
    root.style.setProperty("--dqt-fs", tafFs + "px");
    // header
    var head = el("div", "dqt-head");
    var src = el("div", "dqt-src");
    src.innerHTML = svg(IC.book, 15);
    src.appendChild(el("span", null, tt("src") + " " + info.label));
    head.appendChild(src);
    var chips = el("div", "dqt-chips");
    if (info.range && info.range.indexOf("-") > 0) chips.appendChild(el("span", "dqt-chip", tt("covers") + " " + info.range));
    var words = 0;
    model.secs.forEach(function (s) { s.items.forEach(function (it) { words += ((it.t || it.mean || "").split(/\s+/).length); }); });
    chips.appendChild(el("span", "dqt-chip", "~" + Math.max(1, Math.round(words / 200)) + " " + tt("min")));
    model.meta.forEach(function (m) { var c = el("span", "dqt-chip dqt-chip-m", m); chips.appendChild(c); job({ el: c, t: m }); });
    head.appendChild(chips);
    var tools = el("div", "dqt-tools");
    var dec = el("button", "dqt-tbtn", "A−"), inc = el("button", "dqt-tbtn", "A+");
    dec.type = inc.type = "button";
    dec.setAttribute("aria-label", tt("smaller")); inc.setAttribute("aria-label", tt("larger"));
    var setFs = function (d) {
      tafFs = Math.max(14, Math.min(22, tafFs + d));
      try { localStorage.setItem("dqt-fs", tafFs); } catch (e) {}
      document.querySelectorAll(".dqt").forEach(function (x) { x.style.setProperty("--dqt-fs", tafFs + "px"); });
    };
    dec.addEventListener("click", function (e) { e.stopPropagation(); setFs(-1); });
    inc.addEventListener("click", function (e) { e.stopPropagation(); setFs(1); });
    tools.appendChild(dec); tools.appendChild(inc);
    head.appendChild(tools);
    root.appendChild(head);
    if (arSrc) root.appendChild(el("p", "dqt-note", tt("noteAr")));
    else if (ms) root.appendChild(el("p", "dqt-note", tt("note")));

    var titled = model.secs.filter(function (s) { return s.title; });
    var many = model.secs.length > 3;
    var toc = null;
    if (titled.length >= 2) {
      toc = el("nav", "dqt-toc");
      toc.setAttribute("aria-label", tt("toc"));
      toc.appendChild(el("span", "dqt-toc-l", tt("toc")));
      var tocRow = el("div", "dqt-toc-row");
      toc.appendChild(tocRow);
      if (many) {
        var all = el("button", "dqt-all", tt("expand"));
        all.type = "button";
        all.addEventListener("click", function (e) {
          e.stopPropagation();
          var open = root.querySelectorAll(".dqt-sec:not(.open)").length > 0;
          root.querySelectorAll(".dqt-sec").forEach(function (s) { setOpen(s, open); });
          all.textContent = open ? tt("collapse") : tt("expand");
        });
        toc.appendChild(all);
      }
      root.appendChild(toc);
    }
    function setOpen(s, on) {
      s.classList.toggle("open", on);
      var h = s.querySelector(".dqt-sec-h");
      if (h) h.setAttribute("aria-expanded", on ? "true" : "false");
    }
    var secN = 0;
    model.secs.forEach(function (s, si) {
      curSec = si;
      var sec = el("section", "dqt-sec");
      sec._si = si;
      var body = el("div", "dqt-sec-b");
      if (s.title) {
        secN++;
        var id = "dqt-" + Math.random().toString(36).slice(2, 8);
        var h = el("button", "dqt-sec-h");
        h.type = "button";
        h.innerHTML = '<span class="dqt-n">' + secN + "</span>";
        var ht = el("span", "dqt-sec-t" + (s.arTitle ? " dqt-art" : ""), s.title);
        if (s.arTitle) { ht.lang = "ar"; ht.dir = "rtl"; }
        h.appendChild(ht);
        h.insertAdjacentHTML("beforeend", svg(IC.chev, 16));
        h.setAttribute("aria-controls", id);
        body.id = id;
        h.addEventListener("click", function (e) { e.stopPropagation(); setOpen(sec, !sec.classList.contains("open")); });
        sec.appendChild(h);
        if (!s.arTitle && !s.noTr) job({ el: ht, t: s.title, head: true });
        if (toc) {
          var c = el("button", "dqt-tocc");
          c.type = "button";
          var ct = el("span", s.arTitle ? "dqt-art" : null, s.title);
          if (s.arTitle) { ct.lang = "ar"; ct.dir = "rtl"; }
          c.innerHTML = '<b>' + secN + "</b>";
          c.appendChild(ct);
          if (!s.arTitle && !s.noTr) job({ el: ct, t: s.title, head: true, sec: -1 });
          c.addEventListener("click", function (e) {
            e.stopPropagation();
            setOpen(sec, true);
            sec.scrollIntoView({ behavior: matchMedia("(prefers-reduced-motion: reduce)").matches ? "auto" : "smooth", block: "start" });
            sec.classList.add("dqt-hl"); setTimeout(function () { sec.classList.remove("dqt-hl"); }, 1200);
          });
          tocRow.appendChild(c);
        }
      } else sec.classList.add("dqt-sec-plain");
      setOpen(sec, !s.title || !many || secN <= 1);
      s.items.forEach(function (it) {
        if (it.k === "p") {
          var p = el("p", "dqt-p" + (it.exp ? " dqt-exp" : "") + (arSrc ? " dqt-fromar" : ""));
          setRich(p, it.t);
          body.appendChild(p);
          job({ el: p, t: it.t });
          if (arSrc) {
            var ob = el("button", "dqt-orig", tt("orig"));
            ob.type = "button";
            var ov = el("div", "dqt-origtx", it.t);
            ov.lang = "ar"; ov.dir = "rtl"; ov.hidden = true;
            ob.addEventListener("click", function (e) { e.stopPropagation(); ov.hidden = !ov.hidden; ob.textContent = ov.hidden ? tt("orig") : tt("origHide"); ob.classList.toggle("on", !ov.hidden); });
            body.appendChild(ob); body.appendChild(ov);
          }
          return;
        }
        if (it.k === "isnad") {
          var d = el("details", "dqt-isnad");
          var sm = el("summary", null, tt("isnad"));
          var dv = el("div", "dqt-isnad-t", it.t);
          dv.lang = "ar"; dv.dir = "rtl";
          d.appendChild(sm); d.appendChild(dv);
          d.addEventListener("click", function (e) { e.stopPropagation(); });
          body.appendChild(d);
          return;
        }
        if (it.k === "phrase") {
          var ph = el("div", "dqt-phrase", it.ar);
          ph.lang = "ar"; ph.dir = "rtl";
          body.appendChild(ph);
          return;
        }
        var fig = el("figure", "dqt-q dqt-" + it.k);
        var lab = el("figcaption", "dqt-lab");
        lab.appendChild(el("span", null, it.k === "hadith" ? tt("hadith") : (it.ref ? tt("quoted") : tt("ayah"))));
        if (it.ref) { var rb = el("span", "dqt-refwrap", it.ref); lab.appendChild(rb); }
        fig.appendChild(lab);
        var ar = el("div", "dqt-ar", it.ar);
        ar.lang = "ar"; ar.dir = "rtl";
        fig.appendChild(ar);
        if (it.mean) {
          var mn = el("div", "dqt-mean", it.mean);
          fig.appendChild(mn);
          job({ el: mn, t: it.mean });
        }
        if (it.grade) {
          var g = el("div", "dqt-grade", it.grade);
          fig.appendChild(g);
          job({ el: g, t: it.grade });
        }
        body.appendChild(fig);
      });
      sec.appendChild(body);
      root.appendChild(sec);
    });
    host.innerHTML = "";
    host.appendChild(root);
    try { linkifyVerseRefs(root); } catch (e) {}
    if (!jobs.length) return;
    jobs.forEach(function (j) { j.el.classList.add("dqt-pend"); j.el.setAttribute("aria-busy", "true"); if (j.sl === "ar") j.el.textContent = ""; });
    var secs = root.querySelectorAll(".dqt-sec");
    var feed = function () {
      var ready = jobs.filter(function (j) {
        if (j.queued) return false;
        if (j.sec < 0) return true;
        var se = secs[j.sec];
        return !se || se.classList.contains("open");
      });
      ready.forEach(function (j) { j.queued = true; });
      if (ready.length) translateJobs(root, ready);
    };
    root._feed = feed;
    secs.forEach(function (se) {
      try { new MutationObserver(function () { if (se.classList.contains("open")) feed(); }).observe(se, { attributes: true, attributeFilter: ["class"] }); } catch (e) {}
    });
    feed();
  }
  function translateJobs(root, jobs) {
    var bar = root.querySelector(".dqt-trbar");
    if (!bar) {
      bar = el("div", "dqt-trbar", tt("translating"));
      var head = root.querySelector(".dqt-head");
      head.parentNode.insertBefore(bar, head.nextSibling);
    }
    bar.className = "dqt-trbar"; bar.textContent = tt("translating");
    root._busy = (root._busy || 0) + 1;
    var failed = [];
    var queue = jobs.slice(), active = 0;
    return new Promise(function (resolve) {
      function next() {
        if (!queue.length && !active) return done();
        while (active < 3 && queue.length) {
          (function (j) {
            active++;
            mtProtected(j.t, j.sl || "en", j.tl || "ms").then(function (out) {
              if (!out || !out.trim()) throw new Error("empty");
              if ((j.tl || "ms") === "ms") { try { out = msCleanup(out); if (j.head) out = msSentenceCase(out); } catch (e) {} }
              if (j.el.classList.contains("dqt-p")) setRich(j.el, out); else j.el.textContent = out;
              j.el.classList.remove("dqt-pend"); j.el.classList.remove("dqt-fail");
              j.el.removeAttribute("aria-busy");
              if (/\d{1,3}:\d{1,3}/.test(out)) { try { linkifyVerseRefs(j.el); } catch (e) {} }
            }).catch(function () { failed.push(j); j.el.classList.add("dqt-fail"); })
              .then(function () { active--; next(); });
          })(queue.shift());
        }
      }
      function done() {
        root._busy--;
        if (!failed.length) { if (!root._busy && !root.querySelector(".dqt-fail")) bar.remove(); return resolve(); }
        bar.textContent = tt("trErr") + " ";
        bar.classList.add("err");
        var b = el("button", "q-chip dqp-retry", tt("retry"));
        b.type = "button";
        b.addEventListener("click", function (e) {
          e.stopPropagation(); bar.remove();
          var again = failed.slice(); failed.length = 0;
          translateJobs(root, again);
        });
        bar.appendChild(b);
        resolve();
      }
      next();
    });
  }
  function skeleton(host, msg) {
    host.innerHTML = '<div class="dqt-skel" aria-busy="true"><div class="dqt-skel-t"></div><i></i><i></i><i style="width:72%"></i><div class="dqt-skel-q"></div><i></i><i style="width:58%"></i><span class="dqt-skel-l"></span></div>';
    host.querySelector(".dqt-skel-l").textContent = msg;
  }
  function patchTafsir() {
    try {
      if (typeof loadTafsir !== "function" || loadTafsir._dqt) return;
      var orig = loadTafsir;
      var nl = async function (host, ayahKey, edId, edLabel) {
        var isAr = String(edId).indexOf("ar-") === 0;
        host.classList.remove("dqt-legacy");
        var token = host.__tk = (host.__tk || 0) + 1;
        var skT = setTimeout(function () { if (token === host.__tk && !host.querySelector(".dqt")) skeleton(host, tt("loading")); }, 140);
        try {
          var entries = await fetchTafsirEntries(edId, ayahKey);
          if (token !== host.__tk) return;
          var text = entries.map(function (e) { return rawToText(e.text || ""); }).join("\n\n").trim();
          if (!text) { host.innerHTML = ""; host.appendChild(el("div", "q-note", tt("none"))); return; }
          var range = (entries[0] && (entries[0].range || "")) || "";
          if (entries.length > 1) range = entries[0].range.split("-")[0] + "-" + String(entries[entries.length - 1].range).split(/[-:]/).pop();
          var label = (typeof TAFSIR_EDS !== "undefined" && (TAFSIR_EDS.filter(function (x) { return x.id === edId; })[0] || {}).label) || edLabel || "";
          renderTafsir(host, isAr ? parseArabicTafsir(text) : parseTafsir(text), { label: label, range: range, src: isAr ? "ar" : "en" });
        } catch (e) {
          if (token !== host.__tk) return;
          host.innerHTML = "";
          var box = el("div", "dqt-errbox", tt("err") + " ");
          var b = el("button", "q-chip dqp-retry", tt("retry"));
          b.type = "button";
          b.addEventListener("click", function (ev) { ev.stopPropagation(); nl(host, ayahKey, edId, edLabel); });
          box.appendChild(b);
          host.appendChild(box);
        }
      };
      nl._dqt = true;
      loadTafsir = nl;
    } catch (e) {}
  }
  window.DXQ_parseTafsir = parseTafsir;

  /* ---------------------------------------------------------- motion + comfort features */
  var RM = false;
  try { RM = matchMedia("(prefers-reduced-motion: reduce)").matches; } catch (e) {}
  function reveal() {
    if (RM || !("IntersectionObserver" in window)) return;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (e) {
        if (!e.isIntersecting) return;
        var t = e.target;
        t.style.transitionDelay = (t._dqd || 0) + "ms";
        t.classList.add("dqm-in");
        io.unobserve(t);
        setTimeout(function () { t.style.transitionDelay = ""; t.classList.remove("dqm"); t.classList.remove("dqm-in"); }, 900 + (t._dqd || 0));
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.05 });
    var seen = new WeakSet();
    function scan() {
      var groups = {};
      document.querySelectorAll("#DigitalQuran #dxq-list .card, #DigitalQuran .bento > *, #DigitalQuran section.about, .dqh-text > *, .dqh-ar").forEach(function (c) {
        if (seen.has(c)) return;
        seen.add(c);
        var r = c.getBoundingClientRect();
        if (r.top < innerHeight * 0.9 && r.bottom > 0) return; // already on screen: no animation
        var key = Math.round(r.top / 40);
        groups[key] = (groups[key] || 0) + 1;
        c._dqd = Math.min(groups[key] - 1, 5) * 60;
        c.classList.add("dqm");
        io.observe(c);
      });
    }
    scan();
    try { new MutationObserver(function () { clearTimeout(scan._t); scan._t = setTimeout(scan, 120); }).observe($("dxq-list") || document.body, { childList: true }); } catch (e) {}
  }
  // live waveform stage in the player — real spectrum from the recitation (Web Audio analyser),
  // mirrored from the centre like a voice print; falls back to a speech-like simulation.
  function wave() {
    if (!P || P.querySelector(".dqp-wavebox")) return;
    var box = document.createElement("div");
    box.className = "dqp-wavebox";
    box.setAttribute("aria-hidden", "true");
    var cv = document.createElement("canvas");
    box.appendChild(cv);
    P.insertBefore(box, P.querySelector(".pwrap"));
    var ctx = cv.getContext("2d"), W = 0, H = 0, dpr = 1, N = 0, lv = [], pk = [], raf = 0, freq = null, tuned = false, sim = { t: 0, e: 0, tgt: 0, next: 0 };
    function size() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      var r = box.getBoundingClientRect();
      W = Math.max(2, Math.round(r.width * dpr)); H = Math.max(2, Math.round(r.height * dpr));
      cv.width = W; cv.height = H;
      var step = (r.width < 700 ? 5 : 6) * dpr;
      N = Math.max(24, Math.floor(W / step / 2) * 2);
      while (lv.length < N) { lv.push(0); pk.push(0); }
      lv.length = N; pk.length = N;
    }
    function analyser() {
      try {
        if (typeof vizAnalyser !== "undefined" && vizAnalyser) {
          if (!tuned) { vizAnalyser.fftSize = 2048; vizAnalyser.smoothingTimeConstant = 0.72; vizAnalyser.minDecibels = -92; vizAnalyser.maxDecibels = -18; tuned = true; }
          if (!freq || freq.length !== vizAnalyser.frequencyBinCount) freq = new Uint8Array(vizAnalyser.frequencyBinCount);
          if (vizAC && vizAC.state === "running") return vizAnalyser;
        }
      } catch (e) {}
      return null;
    }
    function frame(ts) {
      raf = 0;
      var playing = audio && !audio.paused && !audio.ended, an = playing ? analyser() : null, half = N / 2;
      var sr = an ? an.context.sampleRate : 44100, binHz = sr / (an ? an.fftSize : 2048);
      if (an) an.getByteFrequencyData(freq);
      else if (playing) { // speech-like envelope: syllable bursts with pauses
        sim.t = ts / 1000;
        if (ts > sim.next) { sim.tgt = Math.random() < 0.18 ? 0.08 : 0.45 + Math.random() * 0.55; sim.next = ts + 90 + Math.random() * 260; }
        sim.e += (sim.tgt - sim.e) * 0.18;
      }
      ctx.clearRect(0, 0, W, H);
      var mid = H / 2, bw = W / N, w = Math.max(1.5 * dpr, bw * 0.5), any = false;
      var g = ctx.createLinearGradient(0, mid - H / 2, 0, mid + H / 2);
      g.addColorStop(0, "rgba(61,123,255,0.15)"); g.addColorStop(0.3, "#3D7BFF"); g.addColorStop(0.5, "#B9CEFF"); g.addColorStop(0.7, "#3D7BFF"); g.addColorStop(1, "rgba(0,69,207,0.15)");
      ctx.fillStyle = g;
      for (var i = 0; i < half; i++) {
        var tgt = 0;
        if (an) {
          // log-spaced 70 Hz → 6 kHz (where a recitation's energy lives), centre = low
          var f0 = 70 * Math.pow(6000 / 70, i / half), f1 = 70 * Math.pow(6000 / 70, (i + 1) / half);
          var b0 = Math.max(1, Math.floor(f0 / binHz)), b1 = Math.max(b0 + 1, Math.ceil(f1 / binHz)), s = 0;
          for (var b = b0; b < b1 && b < freq.length; b++) s = Math.max(s, freq[b]);
          tgt = Math.pow(s / 255, 1.7) * (1.15 - 0.35 * i / half);
        } else if (playing) {
          var x = i / half, shape = Math.exp(-Math.pow((x - 0.18) / 0.32, 2)) * 0.9 + 0.12;
          var fl = 0.55 + 0.45 * Math.sin(i * 0.9 + sim.t * 13 + Math.sin(i * 0.37 + sim.t * 3) * 2);
          tgt = sim.e * shape * fl;
        }
        var cur = lv[i];
        cur += (tgt - cur) * (tgt > cur ? 0.55 : 0.12);
        lv[i] = cur;
        pk[i] = Math.max(cur, pk[i] - 0.012);
        if (cur > 0.004 || pk[i] > 0.01) any = true;
        var h = Math.max(1.4 * dpr, Math.min(1, cur) * (H - 4 * dpr));
        for (var side = 0; side < 2; side++) {
          var idx = side ? half + i : half - 1 - i, x0 = idx * bw + (bw - w) / 2;
          if (ctx.roundRect) { ctx.beginPath(); ctx.roundRect(x0, mid - h / 2, w, h, w / 2); ctx.fill(); }
          else ctx.fillRect(x0, mid - h / 2, w, h);
        }
      }
      // peak dots
      ctx.fillStyle = "rgba(185,206,255,0.55)";
      for (var j = 0; j < half; j++) {
        var ph = Math.min(1, pk[j]) * (H - 4 * dpr) / 2;
        if (ph < 3 * dpr) continue;
        for (var sd = 0; sd < 2; sd++) {
          var id2 = sd ? half + j : half - 1 - j, xx = id2 * bw + bw / 2;
          ctx.fillRect(xx - w / 2, mid - ph - 2 * dpr, w, 1.2 * dpr);
          ctx.fillRect(xx - w / 2, mid + ph + 0.8 * dpr, w, 1.2 * dpr);
        }
      }
      box.classList.toggle("live", playing);
      if (playing || any) raf = requestAnimationFrame(frame);
      else box.classList.remove("live");
    }
    function start() { if (!raf) { size(); raf = requestAnimationFrame(frame); } }
    size();
    window.addEventListener("resize", function () { size(); start(); });
    audio.addEventListener("playing", start);
    audio.addEventListener("play", start);
    audio.addEventListener("pause", start);
    try { new MutationObserver(function () { setTimeout(function () { size(); start(); }, 60); }).observe(P, { attributes: true, attributeFilter: ["class"] }); } catch (e) {}
    start();
  }
  // reading-progress bar for the verse reader
  function readProgress() {
    var body = $("dxq-readBody"), card = body && body.closest(".qread");
    if (!body || !card || card.querySelector(".dqm-prog")) return;
    var bar = document.createElement("div");
    bar.className = "dqm-prog";
    bar.innerHTML = "<i></i>";
    body.parentNode.insertBefore(bar, body);
    var fill = bar.firstChild, raf = 0;
    var upd = function () {
      raf = 0;
      var max = body.scrollHeight - body.clientHeight;
      fill.style.transform = "scaleX(" + (max > 0 ? Math.min(1, body.scrollTop / max) : 0) + ")";
    };
    body.addEventListener("scroll", function () { if (!raf) raf = requestAnimationFrame(upd); }, { passive: true });
    try { new MutationObserver(function () { if (!raf) raf = requestAnimationFrame(upd); }).observe(body, { childList: true }); } catch (e) {}
  }
  // keyboard: space = play/pause, ←/→ = previous/next ayah (only while a surah is loaded and nothing is being typed)
  function keys() {
    document.addEventListener("keydown", function (e) {
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      var a = document.activeElement;
      if (a && (a.isContentEditable || /INPUT|TEXTAREA|SELECT/.test(a.tagName))) return;
      if (J && !J.hidden) return;
      if (document.querySelector("#DigitalQuran .qchat-backdrop:not([hidden])")) return;
      if (!P || !P.classList.contains("up")) return;
      if (e.key === " " && !(a && /BUTTON|A/.test(a.tagName))) { e.preventDefault(); $("dxq-toggle").click(); }
      else if (e.key === "ArrowRight") { e.preventDefault(); stepAyah(1); }
      else if (e.key === "ArrowLeft") { e.preventDefault(); stepAyah(-1); }
    });
  }
  // small toast for actions that otherwise give no feedback
  var toastEl, toastT;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement("div"); toastEl.className = "dqm-toast"; toastEl.setAttribute("role", "status"); document.body.appendChild(toastEl); }
    toastEl.textContent = msg;
    toastEl.classList.add("on");
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove("on"); }, 1800);
  }
  function feedback() {
    document.addEventListener("click", function (e) {
      var t = e.target.closest && e.target.closest("#dxq-shuf, #dxq-rep, #dxq-speed");
      if (!t) return;
      setTimeout(function () {
        var ms = L() === "ms", msg = "";
        if (t.id === "dxq-speed") msg = (ms ? "Kelajuan " : "Speed ") + t.textContent.trim();
        else if (t.id === "dxq-shuf") msg = t.getAttribute("aria-pressed") === "true" ? (ms ? "Rawak: hidup" : "Shuffle on") : (ms ? "Rawak: mati" : "Shuffle off");
        else if (t.id === "dxq-rep") msg = t.getAttribute("aria-label") || "";
        if (msg) toast(msg);
      }, 30);
    });
  }


  /* ---------------------------------------------------------- instant data layer
     Every read-only API response is kept in memory and in IndexedDB, so anything seen
     before opens instantly; next verses / tafsir are fetched ahead of time. */
  var IDB = null;
  (function () {
    try {
      var rq = indexedDB.open("dxq-cache", 1);
      rq.onupgradeneeded = function () { rq.result.createObjectStore("kv"); };
      rq.onsuccess = function () { IDB = rq.result; };
    } catch (e) {}
  })();
  var DAY = 864e5;
  function idbGet(k) {
    return new Promise(function (res) {
      if (!IDB) return res(null);
      try {
        var r = IDB.transaction("kv").objectStore("kv").get(k);
        r.onsuccess = function () { var v = r.result; res(v && Date.now() - v.t < 30 * DAY ? v.v : null); };
        r.onerror = function () { res(null); };
      } catch (e) { res(null); }
    });
  }
  function idbSet(k, v) { try { if (IDB) IDB.transaction("kv", "readwrite").objectStore("kv").put({ t: Date.now(), v: v }, k); } catch (e) {} }
  var CACHE_HOSTS = /^https:\/\/(api\.quran\.com\/api\/v4\/|equran\.id\/api\/|www\.mp3quran\.net\/api\/v3\/ayat_timing)/;
  var memFetch = new Map();
  (function () {
    var of = window.fetch;
    if (!of || of._dqc) return;
    var nf = function (input, init) {
      try {
        var url = typeof input === "string" ? input : (input && input.url) || "";
        var method = (init && init.method) || (input && input.method) || "GET";
        if (method.toUpperCase() === "GET" && CACHE_HOSTS.test(url)) {
          var hit = memFetch.get(url);
          if (!hit) {
            hit = idbGet("f:" + url).then(function (txt) {
              if (txt != null) return txt;
              return of.call(window, url).then(function (r) {
                if (!r.ok) throw new Error("http " + r.status);
                return r.text().then(function (t) { idbSet("f:" + url, t); return t; });
              });
            });
            memFetch.set(url, hit);
            hit.catch(function () { memFetch.delete(url); });
          }
          return hit.then(function (t) { return new Response(t, { status: 200, headers: { "Content-Type": "application/json" } }); });
        }
      } catch (e) {}
      return of.apply(this, arguments);
    };
    nf._dqc = true;
    window.fetch = nf;
  })();
  var memMcp = new Map();
  var realInit = null;
  function patchMcp() {
    try {
      if (typeof mcpTool !== "function" || mcpTool._dqc) return;
      // never let a slow quran.ai cold start block the reader: callers get a quick go-ahead,
      // tool calls still wait for the real session underneath
      if (typeof mcpInit === "function" && !mcpInit._dqc) {
        realInit = mcpInit;
        var fastInit = function () { try { realInit().catch(function () {}); } catch (e) {} return Promise.resolve(true); };
        fastInit._dqc = true;
        mcpInit = fastInit;
        try { realInit().catch(function () {}); } catch (e) {}
      }
      var orig0 = mcpTool;
      var orig = function (n, a) { return (realInit ? realInit() : Promise.resolve()).then(function () { return orig0(n, a); }); };
      var nt = function (name, args) {
        if (!/^fetch_(quran|tafsir|translation)$/.test(name)) return orig(name, args);
        var a = {}; Object.keys(args || {}).sort().forEach(function (k) { if (k !== "grounding_nonce") a[k] = args[k]; });
        var key = "m:" + name + ":" + JSON.stringify(a);
        var hit = memMcp.get(key);
        if (!hit) {
          hit = idbGet(key).then(function (v) {
            if (v != null) return v;
            if (name === "fetch_quran") return raceQuran(orig, args, key);
            return orig(name, args).then(function (t) {
              var good = false;
              try { var j = JSON.parse(t); good = !!(j && j.results); } catch (e) {}
              if (good) idbSet(key, t); else memMcp.delete(key);
              return t;
            });
          });
          memMcp.set(key, hit);
          hit.catch(function () { memMcp.delete(key); });
        }
        return hit;
      };
      nt._dqc = true;
      mcpTool = nt;
    } catch (e) {}
  }
  // fetch_quran: if quran.ai is slow (cold start / 502 retries), build the same answer from api.quran.com
  function quranFallback(ayahs) {
    var m = /^(\d{1,3}):(\d{1,3})(?:-(\d{1,3}))?$/.exec(String(ayahs || "").trim());
    if (!m) return Promise.reject(new Error("shape"));
    var keys = [];
    for (var a = +m[2]; a <= (+m[3] || +m[2]); a++) keys.push(m[1] + ":" + a);
    return Promise.all(keys.map(function (k) {
      return fetch("https://api.quran.com/api/v4/verses/by_key/" + k + "?fields=text_uthmani").then(function (r) { return r.json(); })
        .then(function (j) { return { ayah: k, text: String((j.verse || {}).text_uthmani || "").trim(), citation_url: null }; });
    })).then(function (list) {
      if (list.some(function (x) { return !x.text; })) throw new Error("incomplete");
      return JSON.stringify({ ayahs: keys, results: { "ar-uthmani-hafs": list, "ar-simple-clean": list } });
    });
  }
  function raceQuran(orig, args, key) {
    return new Promise(function (res, rej) {
      var done = false, fails = 0;
      var win = function (t, cacheIt) { if (done) return; done = true; if (cacheIt) idbSet(key, t); res(t); };
      var lose = function (e) { if (++fails >= 2 && !done) { done = true; memMcp.delete(key); rej(e); } };
      orig("fetch_quran", args).then(function (t) {
        var ok = false; try { ok = !!JSON.parse(t).results; } catch (e) {}
        if (ok) win(t, true); else lose(new Error("bad"));
      }, lose);
      quranFallback(args && args.ayahs).then(function (t) { win(t, true); }, lose);
    });
  }
  var QC_TAF = { "en-ibn-kathir": 169, "en-maarif-ul-quran": 168, "ar-muyassar": 16, "ar-al-wasit": 93, "ar-saadi": 91, "ar-baghawi": 94, "ar-qurtubi": 90, "ar-tabari": 15 };
  function fetchTafsirEntries(edId, key) {
    var viaMcp = function () {
      return mcpInit().then(function () { return mcpTool("fetch_tafsir", { ayahs: key, editions: [edId] }); }).then(function (raw) {
        var en = []; try { en = (JSON.parse(raw).results || {})[edId] || []; } catch (e) {}
        return en.map(function (e) { return { range: e.range || key, text: e.text || "" }; });
      });
    };
    var id = QC_TAF[edId];
    if (!id) return viaMcp();
    return fetch("https://api.quran.com/api/v4/tafsirs/" + id + "/by_ayah/" + key).then(function (r) { if (!r.ok) throw new Error("qc " + r.status); return r.json(); })
      .then(function (j) {
        var t = (j && j.tafsir) || {}, ks = Object.keys(t.verses || {});
        if (!t.text || !String(t.text).trim()) throw new Error("empty");
        var range = ks.length > 1 ? ks[0] + "-" + ks[ks.length - 1].split(":")[1] : key;
        return [{ range: range, text: t.text }];
      }).catch(function () { return viaMcp(); });
  }
  function idle(fn, t) { (window.requestIdleCallback || function (f) { return setTimeout(f, 200); })(fn, { timeout: t || 2000 }); }
  // background fetches run one at a time and yield to anything the reader is loading
  var warmQ = [], warmBusy = false, warmSeen = {};
  function pump() {
    if (warmBusy || !warmQ.length) return;
    try { if (rd && rd.busy) { setTimeout(pump, 400); return; } } catch (e) {}
    var job = warmQ.shift();
    warmBusy = true;
    Promise.resolve().then(job).catch(function () {}).then(function () { warmBusy = false; setTimeout(pump, 60); });
  }
  function warm(key, fn, urgent) {
    if (warmSeen[key]) return;
    warmSeen[key] = 1;
    if (urgent) warmQ.unshift(fn); else warmQ.push(fn);
    pump();
  }
  function warmBatch(s, from, urgent) {
    try {
      if (!s || from > s.y) return;
      var to = Math.min(from + 9, s.y), ref = s.n + ":" + from + (to > from ? "-" + to : "");
      warm("b" + ref + L(), function () {
        var tr = Promise.resolve();
        try { tr = fetchVerseTranslations(ref).catch(function () {}); } catch (e) {}
        return Promise.all([mcpInit().then(function () { return mcpTool("fetch_quran", { ayahs: ref }); }), tr]);
      }, urgent);
    } catch (e) {}
  }
  var warmedTaf = {};
  function warmTafsir(key) {
    try {
      var ed = (TAFSIR_EDS && TAFSIR_EDS[0] && TAFSIR_EDS[0].id) || "en-ibn-kathir", k = ed + "|" + key + "|" + L();
      if (warmedTaf[k]) return;
      warmedTaf[k] = 1;
      warm("t" + k, function () { return fetchTafsirEntries(ed, key).then(function (entries) {
        if (L() !== "ms") return;
        // pre-translate the first part so BM tafsir opens with text already in Malay
        var text = entries.map(function (e) { return rawToText(e.text || ""); }).join("\n\n");
        var m = parseTafsir(text), list = [];
        m.meta.forEach(function (x) { list.push(x); });
        m.secs.forEach(function (sc) { if (sc.title && !sc.arTitle) list.push(sc.title); sc.items.forEach(function (it) { if (it.t) list.push(it.t); if (it.mean) list.push(it.mean); if (it.grade) list.push(it.grade); }); });
        list = list.slice(0, 24);
        var i = 0;
        (function nextOne() { if (i >= list.length) return; mtProtected(list[i++], "en", "ms").catch(function () {}).then(function () { setTimeout(nextOne, 60); }); })();
      }); });
    } catch (e) {}
  }
  function prefetchers() {
    patchMcp();
    var body = $("dxq-readBody");
    // reader: as soon as a batch is on screen, fetch the next one + tafsir for the first ayat
    if (body) new MutationObserver(function () {
      try {
        if (!rd || !rd.s) return;
        setTimeout(function () { if (rd && rd.s) warmBatch(rd.s, rd.next, true); }, 300);
        var first = body.querySelector(".rv[data-key]");
        if (first) idle(function () { warmTafsir(first.dataset.key); }, 4000);
      } catch (e) {}
    }).observe(body, { childList: true });
    // tafsir chips / surah cards: start fetching on intent (hover, touch, focus)
    var intent = function (e) {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var rv = t.closest("#dxq-readBody .rv[data-key]");
      if (rv && t.closest("button")) { warmTafsir(rv.dataset.key); return; }
      var card = t.closest("#dxq-list .card, .dqh-quick [data-surah]");
      if (card) {
        var n = card.dataset.surah ? +card.dataset.surah : (+card.dataset.i + 1);
        var su = S() && S()[n - 1];
        if (su) warmBatch(su, 1, true);
      }
    };
    ["pointerover", "touchstart", "focusin"].forEach(function (ev) { document.addEventListener(ev, intent, { passive: true, capture: true }); });
    // idle warm-up: connection + the most-read surahs + verse of the day
    idle(function () {
      try {
        mcpInit().then(function () {
          [36, 18, 67, 1].forEach(function (n) { warmBatch(S()[n - 1], 1); });
          try { if (typeof dailyKey === "string" && dailyKey) { var pr = dailyKey.split(":"); warmBatch(S()[+pr[0] - 1], +pr[1]); } } catch (e) {}
        }).catch(function () {});
      } catch (e) {}
    }, 6000);
  }
  /* ---------------------------------------------------------- boot */
  function dropCredit() {
    document.querySelectorAll('#DigitalQuran section.about a[rel="author"]').forEach(function (a) { var p = a.closest("p"); if (p) p.remove(); });
  }
  function boot() {
    dropCredit();
    if (!S() || !$("dxq-player") || !$("dxq-audio")) return false;
    patchLanguage();
    patchTafsir();
    build();
    try { reveal(); readProgress(); keys(); feedback(); } catch (e) {}
    try { wave(); } catch (e) {}
    try { prefetchers(); } catch (e) {}
    readerAdd();
    hookSearch();
    var lastLang = L();
    document.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest("#dxq-langEn, #dxq-langMs, [data-dqh-lang]")) setTimeout(function () {
        labels(); hookSearch();
        if (L() !== lastLang) { lastLang = L(); relangReader(); }
      }, 30);
    }, true);
    document.addEventListener("keydown", function (e) {
      // "g" opens the jump sheet when nothing is being typed
      if (e.key !== "g" || e.ctrlKey || e.metaKey || e.altKey) return;
      var a = document.activeElement;
      if (a && (a.isContentEditable || /INPUT|TEXTAREA|SELECT/.test(a.tagName))) return;
      if (J && !J.hidden) return;
      openJump();
    });
    sync();
    return true;
  }
  var n = 0;
  (function wait() {
    if (boot()) return;
    if (++n < 200) setTimeout(wait, 100);
  })();
  window.DXQ_openJump = openJump;
})();
